<template>
  <button @click="handleClick" :class="['ypo-toggle-button', `ypo-toggle-button--${buttonColor}`]">
    <span class="toggle-icon" :class="[isToggledOn && 'toggle-icon--on']"><i class="fas fa-circle"></i></span>
    <span class="ypo-toggle-button__label" :class="[isToggledOn && 'toggle-label--on']">{{ buttonLabel }}</span>
  </button>
</template>

<script>
import { ypoToggleButtonConstant } from './ypoComponents.constant';

export default {
  name: 'YpoToggleButton',
  props: {
    clickCallback: {
      type: Function,
      required: true,
    },
    isToggledOn: {
      type: Boolean,
      required: true,
      default: false,
    },
    defaultToggleLabel: {
      type: String,
      required: true,
      default: () => ypoToggleButtonConstant.defaultToggleLabel,
    },
    postToggleLabel: {
      type: String,
      required: true,
      default: () => ypoToggleButtonConstant.postToggleLabel,
    },
    toggleDefaultColor: {
      type: String,
      default: () => ypoToggleButtonConstant.toggleDefaultColor,
    },
    postToggleColor: {
      type: String,
      default: () => ypoToggleButtonConstant.postToggleColor,
    },
  },
  data: () => ({
    ypoToggleButtonConstant,
  }),
  methods: {
    handleClick() {
      if (this.clickCallback) this.clickCallback();
    },
  },
  computed: {
    buttonLabel() {
      return this.isToggledOn ? this.defaultToggleLabel : this.postToggleLabel;
    },
    buttonColor() {
      return this.isToggledOn ? this.toggleDefaultColor : this.postToggleColor;
    },

  },
};
</script>

<style lang="scss" scoped>
@import '../../common/ypoStyles/main';
.ypo-toggle-button {
  border-radius: 12px;
  position: relative;
  padding: 0 0 2px;
  border: 2px solid $ypo-dark-background-gray;

  &__label {
    padding: 0 15px 0 30px;
    color: $white;
    font-size: 12px;
    text-transform: uppercase;
  }
  .toggle-icon {
    position: absolute;
    left: -1px;
    bottom: -2px;
    transition: all 0.2s linear;

    i {
      color: $white;
      font-size: 22px;
    }
  }

  .toggle-icon--on {
    position: absolute;
    left: 81%;
  }

  .toggle-label--on {
    padding: 0 30px 0 15px;
  }
}

//available background colors
.ypo-toggle-button {
  &--blue {
    background-color: $ypo-cta;
  }

  &--green {
    background-color: $ypo-medium-green;
  }
}
</style>
